import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  fetchBureauConnections(
    { state },
    { pageSize, pageNumber, key, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.bureauConnection.getBureauConnections}?PageNumber=${pageNumber}&PageSize=${pageSize}&Key=${key}&Value=${value}&sortBy=${sortBy}&sortDirection=${sortDirection}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  getConnectionByName({ state }, name) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.bureauConnection.getConnectionByName}/${name}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  saveSelectedBureauCustomers({ state }, selectedCustomers) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.bureauConnection.assignBureauConnection}`,
        selectedCustomers,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchSelectedBureauCustomers({ state }, id) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.bureauConnection.getAssignedCustomer}/${id}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  getBureauCustomer({ state }, name) {
    if (name) {
      return axios
        .get(
          `${appConfig.apiEndPoint}${endpoint.bureauConnection.getCustomer}/${name}/1`,
          {
            headers: setHeaders(),
          }
        )
        .then((response) => {
          return response
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            return null
          }
          return error
        })
    }
  },
  enableDisableConnection({ state }, { id, status } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.bureauConnection.updateConnectionStatus}/${id}/${status}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  createConnectionSubmit({ state }, connectionCreateData) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.bureauConnection.createConnectionSubmit}`,
        connectionCreateData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },

  fetchConnectionDetails({ state }, index) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.bureauConnection.fetchConnectionDetails}/${index}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },

  updateConnectionSubmit({ state }, connectionCreateData) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.bureauConnection.updateConnectionSubmit}`,
        connectionCreateData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
